import { render } from "./Footer.vue?vue&type=template&id=480d1918&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=480d1918&scoped=true&lang=scss"

import exportComponent from "/Users/wangwangxinkai/Documents/PBM/tianke-1/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-480d1918"]])

export default __exports__